module.exports = __webpack_public_path__ + "static/media/hVqQoKi.52a9d803.png";